import React, { Fragment, useState } from "react";
import { useLoginStatus } from "../../AppMain/LoginStatusContext";
import { useUserEmail } from "../../AppMain/LoginStatusContext";

import { useQuery, useMutation } from "@apollo/client";
import { Link } from "react-router-dom";
import {
  GET_USER_PROF,
  READ_NOTICE_QUERY,
  READ_NOTICE,
} from "../../../queries";

import {
  DropdownToggle,
  DropdownMenu,
  Button,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { BsBell } from "react-icons/bs";

import bc from "../../../assets/utils/images/dropdown-header/abstract7.jpg";
import ema from "../../../assets/utils/images/originals/logo.png";
import { sendGAEvent } from "../../../utils";

const UserBox = ({ onRegisterClick }) => {
  const loginStatus = useLoginStatus();
  const userEmail = useUserEmail();

  const { loading, error, data, refetch } = useQuery(GET_USER_PROF, {
    variables: { email: userEmail },
  });

  const {
    loading: read_notice_loading,
    error: read_notice_error,
    data: notifications,
    refetch: refetch_notification_query,
  } = useQuery(READ_NOTICE_QUERY);

  const [readNotice, { resultData }] = useMutation(READ_NOTICE, {
    onCompleted() {
      refetch();
    },
  });

  const [checkZeroNotice, setCheckZeroNotice] = useState(false);
  const changeReadNotice = async () => {
    try {
      await readNotice({ variables: { userId: userId } });
    } catch (err) {
      setCheckZeroNotice(true);
    }
  };

  //ログアウト関数
  const logout = async (e) => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("tabActive");
      alert("ログアウトしました");
      window.location.href = "/#/dashboards/journy";
      document.location.reload();
    } catch (err) {
      alert(err.message);
    }
  };

  const userId =
    data &&
    data.allUsers &&
    data.allUsers.edges[0] &&
    data.allUsers.edges[0].node.id;

  const userName =
    data && data.allUsers && data.allUsers.edges[0]
      ? data.allUsers.edges[0].node.additionalInfo &&
        data.allUsers.edges[0].node.additionalInfo.username
      : "None USERNAME";

  const userOrg =
    data &&
    data.allUsers &&
    data.allUsers.edges[0] &&
    data.allUsers.edges[0].node.myOrgName;

  const iconUrl =
    data &&
    data.allUsers &&
    data.allUsers.edges[0] &&
    data.allUsers.edges[0].iconUrl;

  const notification__icon = {
    width: "45px",
    borderRadius: "100px",
    height: "100%",
    margin: "auto 0",
  };
  const notification__itemWrapper = { display: "flex", flexDirection: "row" };

  return (
    <Fragment>
      {loginStatus ? (
        <div className="header-btn-lg pr-0">
          <div className="notification__area">
            <UncontrolledButtonDropdown>
              <DropdownToggle
                color="link"
                className="p-0"
                onClick={() => {
                  sendGAEvent(
                    "pageview",
                    "/#/dashboards/journy/notification_tab"
                  );
                }}
              >
                <BsBell
                  className="notification__bell"
                  onClick={changeReadNotice}
                />
                {data &&
                  data.allUsers &&
                  data.allUsers.edges[0] &&
                  data.allUsers.edges[0].node.hasNotice &&
                  data.allUsers.edges[0].node.hasNotice.hasNotice && (
                    <span className="dot"></span>
                  )}
              </DropdownToggle>
              <DropdownMenu
                right
                className="rm-pointers dropdown-menu-lg"
                style={{ paddingBottom: 0, paddingTop: 0 }}
              >
                <div
                  className="notif__header bold"
                  style={{
                    backgroundImage: "url(" + bc + ")",
                  }}
                >
                  News !
                </div>
                <ul className="notif__lists" id="notif__lists">
                  {notifications &&
                  notifications.allNotifications &&
                  notifications.allNotifications.edges &&
                  notifications.allNotifications.edges[0] ? (
                    <>
                      <div>
                        {notifications.allNotifications.edges.map(
                          (arry, key) => (
                            <li style={notification__itemWrapper} key={key}>
                              <img src={ema} style={notification__icon} />
                              <span>
                                <span>{arry.node.noticedAt}</span>
                                <a href={arry.node.link} target="_blank">
                                  {arry.node.title}
                                </a>
                              </span>
                            </li>
                          )
                        )}
                      </div>
                    </>
                  ) : (
                    <p style={{ padding: 16, margin: 0 }}>
                      お知らせはありません
                    </p>
                  )}
                </ul>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
          <div className="widget-content p-0">
            <div className="widget-content-wrapper">
              <div className="widget-content-left">
                <UncontrolledButtonDropdown>
                  <DropdownToggle color="link" className="p-0">
                    <img
                      width={42}
                      height={42}
                      className="rounded-circle"
                      src={
                        data &&
                        data.allUsers &&
                        data.allUsers.edges[0] &&
                        data.allUsers.edges[0].node.iconUrl
                          ? data.allUsers.edges[0].node.iconUrl
                          : "https://emasocialmap.s3.ap-northeast-1.amazonaws.com/media/icon.png"
                      }
                      alt=""
                      style={{ objectFit: "cover" }}
                    />
                  </DropdownToggle>
                  <DropdownMenu
                    right
                    className="rm-pointers dropdown-menu-lg"
                    style={{ paddingBottom: 0 }}
                  >
                    {data &&
                      data.allUsers &&
                      data.allUsers.edges.map((array, i) => (
                        <div
                          key={i}
                          className="dropdown-menu-header"
                          style={{ marginBottom: 0 }}
                        >
                          <div className="dropdown-menu-header-inner bg-info">
                            <div
                              className="menu-header-image opacity-3"
                              style={{
                                backgroundImage: "url(" + bc + ")",
                              }}
                            />
                            <div className="menu-header-content text-left">
                              <div className="widget-content p-0">
                                <div
                                  className="widget-content-wrapper"
                                  style={{ justifyContent: "left" }}
                                >
                                  <div className="widget-content-left mr-3">
                                    <img
                                      width={42}
                                      height={42}
                                      className="rounded-circle"
                                      src={
                                        data &&
                                        data.allUsers &&
                                        data.allUsers.edges[0] &&
                                        data.allUsers.edges[0].node.iconUrl
                                          ? data.allUsers.edges[0].node.iconUrl
                                          : "https://emasocialmap.s3.ap-northeast-1.amazonaws.com/media/icon.png"
                                      }
                                      alt=""
                                      style={{ objectFit: "cover" }}
                                    />
                                  </div>
                                  <div className="widget-content-left">
                                    <div>
                                      {userName === "0" ||
                                      userName == null ||
                                      userName.trim() === "" ? (
                                        <div className="widget-heading">
                                          名前が登録されていません
                                        </div>
                                      ) : (
                                        <div className="widget-heading">
                                          {userName}
                                        </div>
                                      )}
                                    </div>

                                    <div className="widget-subheading opacity-8">
                                      {userOrg}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="widget-content-right mr-2"
                                  style={{ marginTop: 10, marginLeft: 53 }}
                                >
                                  <Button
                                    className="btn-pill btn-shadow btn-shine"
                                    color="focus"
                                    onClick={() => logout()}
                                  >
                                    ログアウト
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="header-btn-lg pr-0">
          <div className="widget-content p-0">
            <div className="widget-content-wrapper">
              <div className="headerBtnBox">
                <UncontrolledButtonDropdown>
                  <DropdownToggle
                    color="link"
                    className="p-0"
                    Jou
                    onClick={() => {
                      sendGAEvent(
                        "pageview",
                        "/#/dashboards/journy/notification_tab"
                      );
                    }}
                  >
                    <BsBell className="notification__bell" />
                  </DropdownToggle>
                  <DropdownMenu
                    right
                    className="rm-pointers dropdown-menu-lg"
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                  >
                    <div
                      className="notif__header bold"
                      style={{
                        backgroundImage: "url(" + bc + ")",
                      }}
                    >
                      News !
                    </div>
                    <ul className="notif__lists" id="notif__lists">
                      {notifications &&
                      notifications.allNotifications &&
                      notifications.allNotifications.edges &&
                      notifications.allNotifications.edges[0] ? (
                        <>
                          <div>
                            {notifications.allNotifications.edges.map(
                              (arry, key) => (
                                <li style={notification__itemWrapper} key={key}>
                                  <img src={ema} style={notification__icon} />
                                  <span>
                                    <span>{arry.node.noticedAt}</span>
                                    <a href={arry.node.link} target="_blank">
                                      {arry.node.title}
                                    </a>
                                  </span>
                                </li>
                              )
                            )}
                          </div>
                        </>
                      ) : (
                        <p style={{ padding: 16, margin: 0 }}>
                          お知らせはありません
                        </p>
                      )}
                    </ul>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
                <Link to="/pages/login" className="headerBtn pointer hide-sp">
                  ログイン
                </Link>
                {/* <Link to="/pages/register" className="headerBtn pointer">
                  新規登録
                </Link> */}
                {/* <p onClick={onRegisterClick} className="headerBtn pointer">
                  新規登録
                </p> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default UserBox;
